// extracted by mini-css-extract-plugin
export default {"card":"FormEmail_card__PnIXY","form":"FormEmail_form__FgQIG","errors":"FormEmail_errors__dTv5G","errors__icon":"FormEmail_errors__icon__x6jRq","message":"FormEmail_message__wlwTz"};